import LegalPageLayout from "@/components/LegalPageLayout";
import { Download } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const PDF_URL = "/documents/LEG-RD-066_V1.0.pdf";

const SupplierCodeOfConduct = () => {
  const lang = useLanguage();

  if (lang === "es") {
    return (
      <LegalPageLayout
        title="Código de conducta del proveedor"
        description="Código de conducta del proveedor de QbD Group: nuestras expectativas en materia de prácticas empresariales éticas, sostenibles y responsables."
        path="/es/codigo-de-conducta-del-proveedor"
      >
        <p><strong>Fecha de entrada en vigor: 22 de julio de 2025</strong></p>

        <p>En QbD Group, nos esforzamos por construir relaciones sólidas, transparentes y de confianza con todos aquellos con quienes trabajamos, incluidos nuestros proveedores. Este Código de conducta del proveedor establece los principios y expectativas clave que guían nuestra colaboración. Se aplica a todos los proveedores, contratistas y subcontratistas que prestan servicios para o en nombre de QbD Group.</p>

        <p>No transigimos en materia de ética ni cumplimiento normativo. Este Código describe los estándares mínimos que esperamos en áreas como la integridad, la sostenibilidad, la seguridad y las prácticas empresariales responsables. Complementa, pero no sustituye, los términos de tu contrato y forma parte de cómo garantizamos la calidad, la equidad y las alianzas a largo plazo.</p>

        <div className="my-8 p-6 rounded-2xl border border-border bg-muted/50 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1">
            <p className="font-semibold text-foreground mb-1">Descargar el documento completo</p>
            <p className="text-sm text-muted-foreground">Código de conducta del proveedor (PDF, inglés)</p>
          </div>
          <a
            href={PDF_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary text-primary-foreground text-sm font-semibold hover:opacity-90 transition-opacity shrink-0"
          >
            <Download className="h-4 w-4" />
            Descargar PDF
          </a>
        </div>
      </LegalPageLayout>
    );
  }

  if (lang === "zh-cn") {
    return (
      <LegalPageLayout
        title="供应商行为准则"
        description="QbD Group 的供应商行为准则——我们对道德、可持续和负责任商业实践的期望。"
        path="/zh-cn/supplier-code-of-conduct"
      >
        <p><strong>生效日期：2025年7月22日</strong></p>

        <p>在 QbD Group，我们致力于与包括供应商在内的所有合作伙伴建立牢固、透明和值得信赖的关系。本供应商行为准则阐述了指导我们合作的关键原则和期望，适用于为 QbD Group 提供服务或代表 QbD Group 提供服务的所有供应商、承包商和分包商。</p>

        <p>我们在道德和合规方面绝不妥协。本准则概述了我们在诚信、可持续发展、安全和负责任商业实践等方面的最低标准。它是对合同条款的补充而非替代，也是我们确保质量、公平和长期合作的方式之一。</p>

        <div className="my-8 p-6 rounded-2xl border border-border bg-muted/50 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1">
            <p className="font-semibold text-foreground mb-1">下载完整文档</p>
            <p className="text-sm text-muted-foreground">供应商行为准则（PDF，英文版）</p>
          </div>
          <a
            href={PDF_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary text-primary-foreground text-sm font-semibold hover:opacity-90 transition-opacity shrink-0"
          >
            <Download className="h-4 w-4" />
            下载 PDF
          </a>
        </div>
      </LegalPageLayout>
    );
  }

  return (
    <LegalPageLayout
      title="Supplier Code of Conduct"
      description="QbD Group's Supplier Code of Conduct — our expectations for ethical, sustainable, and responsible business practices."
      path="/en/supplier-code-of-conduct"
    >
      <p><strong>Effective date: 22 July 2025</strong></p>

      <p>At QbD Group, we aim to build strong, transparent, and trustworthy relationships with everyone we work with including our suppliers. This Supplier Code of Conduct sets out the key principles and expectations that guide how we collaborate. It applies to all suppliers, contractors, and subcontractors who deliver services for or on behalf of QbD Group.</p>

      <p>We don't compromise on ethics or compliance. This Code outlines the minimum standards we expect in areas like integrity, sustainability, safety, and responsible business practices. It supports, but doesn't replace, the terms in your contract and is part of how we ensure quality, fairness, and long-term partnership.</p>

      <div className="my-8 p-6 rounded-2xl border border-border bg-muted/50 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="font-semibold text-foreground mb-1">Download the full document</p>
          <p className="text-sm text-muted-foreground">Supplier Code of Conduct (PDF, English)</p>
        </div>
        <a
          href={PDF_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary text-primary-foreground text-sm font-semibold hover:opacity-90 transition-opacity shrink-0"
        >
          <Download className="h-4 w-4" />
          Download PDF
        </a>
      </div>
    </LegalPageLayout>
  );
};

export default SupplierCodeOfConduct;
